import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';

import * as io from "socket.io-client";

@Injectable()
export class SyncIO {
  socket: any;
  status: boolean = false;
  online: boolean = false;
  userId: any;
  position: any;
  time: any;

  constructor() {}

  connect(){
    let self = this;
    this.socket = io('http://barbosa.ibrs.com.br:4032/io');
    this.socket.on('connect', function(data){
      console.log('conectado');
      self.status = true;
    });

    this.socket.on('disconnect', function(data){
      console.log('desconectado');
      self.status = false;
    });
  }

  send(data,canal) {
    console.log('Send')
    this.socket.emit(canal,data);
  }

  getStatus(){
    return this.status;
  }
}



// WEBPACK FOOTER //
// ./src/providers/sync/sync.ts